document.addEventListener('DOMContentLoaded', function () {
    var hamburgerBtn = document.getElementById('hamburger-btn');
    var dropdownMenu = document.getElementById('dropdown-menu');
    var subcategoryMenu = document.getElementById('subcategory-menu');
    var categories = document.querySelectorAll('.category');
    var subcategories = document.querySelectorAll('.subcategory');
    var subcategoryLinks = document.querySelectorAll('.subcategory ul li a');

    hamburgerBtn.addEventListener('click', function () {
        if (dropdownMenu.style.display === 'block') {
            dropdownMenu.style.display = 'none';
            subcategoryMenu.style.display = 'none';
        } else {
            dropdownMenu.style.display = 'block';
        }
    });

    categories.forEach(function(category) {
        category.addEventListener('click', function() {
            var categoryType = this.getAttribute('data-category');
            subcategories.forEach(function(subcategory) {
                if (subcategory.getAttribute('data-category') === categoryType) {
                    subcategoryMenu.style.display = 'block';
                    subcategory.style.display = 'block';
                } else {
                    subcategory.style.display = 'none';
                }
            });
        });
    });

     document.addEventListener('DOMContentLoaded', function () {
        const subcategoryLinks = document.querySelectorAll('.subcategory a');

        subcategoryLinks.forEach(link => {
            link.addEventListener('click', function (event) {
   });
        });
    });

    // Close the dropdown if the user clicks outside of it
    window.onclick = function (event) {
        if (!event.target.matches('#hamburger-btn') && !event.target.closest('.category') && !event.target.closest('.subcategory-menu')) {
            if (dropdownMenu.style.display === 'block') {
                dropdownMenu.style.display = 'none';
                subcategoryMenu.style.display = 'none';
            }
        }
    }
});


document.addEventListener('DOMContentLoaded', function() {
    var backButtons = document.querySelectorAll('.back-button');
    var dynamicSubcategoriesContainers = document.querySelectorAll('.dynamic-subcategories');
    var mainCategoriesContainers = document.querySelectorAll('.subcategory > ul');

    function openSubcategory(event) {
        event.preventDefault();
        var submenuId = event.currentTarget.dataset.submenu;
        var submenu = document.getElementById(submenuId);
        var dynamicSubcategoriesContainer = event.currentTarget.closest('.subcategory').querySelector('.dynamic-subcategories');
        var mainCategoriesContainer = event.currentTarget.closest('.subcategory').querySelector('ul');

        // Check if the submenu exists and has content
        if (submenu && dynamicSubcategoriesContainer && mainCategoriesContainer) {
            if (submenu.children.length > 0) {
                mainCategoriesContainer.style.display = 'none';
                submenu.style.display = 'block';
                dynamicSubcategoriesContainer.innerHTML = '';
                dynamicSubcategoriesContainer.appendChild(submenu);
                
                var backButton = event.currentTarget.closest('.subcategory').querySelector('.back-button');
                backButton.style.display = 'block';
            } else {
                // If there are no subcategories, redirect to the URL directly
                window.location.href = event.currentTarget.href;
            }
        }
    }

    function goBack(event) {
        var backButton = event.currentTarget;
        var mainCategoriesContainer = backButton.closest('.subcategory').querySelector('ul');
        var dynamicSubcategoriesContainer = backButton.closest('.subcategory').querySelector('.dynamic-subcategories');

        mainCategoriesContainer.style.display = 'block';
        dynamicSubcategoriesContainer.innerHTML = '';
        backButton.style.display = 'none';
    }

    var subcategoryLinks = document.querySelectorAll('.has-subcategories');
    subcategoryLinks.forEach(function(link) {
        link.addEventListener('click', openSubcategory);
    });

    backButtons.forEach(function(button) {
        button.addEventListener('click', goBack);
    });
});


